import React, { useEffect, useState } from 'react'
import useApi from '../../hooks/useApi';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import moment from 'moment';
import { apiUrls } from '../../utils/api/apiUrls';
import { toast } from 'react-toastify';
import { downloadReportsFun, getArrayOfSelectedStoresCode } from '../../../srcWeb/utils/helpers';
import ToolbarHeader from '../../components/ToolbarHeader';
import DatePicker from '../../components/FormFields/DatePicker';
import DetailsCard from '../../components/DetailsCard';
import { useMediaQuery } from 'react-responsive';
import CustomButton from '../../components/CustomButton';
import { displayDateFormat } from '../../utils/helpers';

export const SapReport = () => {
    const { data = [], apiCall } = useApi();
    const { data: data1 = [], apiCall: apiCall1 } = useApi();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const {
      user: { userLabel = "Store" },
      selectedStores,
      storeDropdownState
    } = useAuth();
    const isMobileSmall = useMediaQuery({ query: "(max-width: 344px)" });
    const [startDate, setStartDate] = useState(
      moment(
        searchParams.get("startDate") || moment().subtract({ days: 7 }).toDate()
      ).toDate()
    );
  
    const [endDate, setEndDate] = useState(
      moment(searchParams.get("endDate") || new Date()).toDate()
    );
  
    useEffect(() => {
      voucherApiCall(startDate, endDate);
    }, [selectedStores]);
  
    // const {storeCode = ""} = selectedStores?.storeDetails || {}
    const {storeCode = ""} = selectedStores?.storeDetails || selectedStores?.[0] || {}

    
    const {data: fileData,  apiCall: fileDownload } = useApi();
  
    const downloadFileFun = () => {
        const st =`${moment(startDate).format('YYYY-MM-DD')} 00:00:00`;
        const et = `${moment(endDate).format('YYYY-MM-DD')} 23:59:59`;
        fileDownload({
          url: `${apiUrls.dmsService.downloadVouchersSAPUploaderFormat}?endDate=${et}&startDate=${st}&metaDataSchemaId=4&storeCode=${storeCode}`,
          method: "post",
          responseType: "blob",
          responseData: (res) => {
            const { data = "", status = null } = res || {};
            const contentType = res?.headers?.["content-type"];
            const contentDisposition = res?.headers["content-disposition"];
            const fileNameMatch =
              contentDisposition && contentDisposition.match(/filename="(.+)"/);
            const fileName = fileNameMatch
              ? fileNameMatch[1]
              : "voucher_sap_uploader_format_report.xlsx";
            if(status === 200) {
              toast.success("Download File Successfully");
              downloadReportsFun(data, fileName, contentType);
            } else {
              toast.success("Something Went Wrong");
            }
          },
        });
    }
    const voucherApiCall = (start, end) => {
      // navigate(
      //   {
      //     pathname: window.location.pathname,
      //     search: createSearchParams({
      //       startDate: start,
      //       endDate: end,
      //     }).toString(),
      //   },
      //   { replace: true }
      // );
        apiCall1({
          url: apiUrls.dmsService.getRecords,
          dataToSend: {
            startDate: moment(start).startOf("d").format("YYYY-MM-DD HH:mm:ss"),
            metadataSchemaId: 4,
            endDate: moment(end || start)
              .endOf("d")
              .format("YYYY-MM-DD HH:mm:ss"),
            searchText: "",
            status: "APPROVED",
            storeCodes: getArrayOfSelectedStoresCode(selectedStores, storeDropdownState)
            // storeCodes: selectedStores?.storeDetails?.storeCode
            // ? selectedStores?.storeDetails?.storeCode !== "All" ? [selectedStores?.storeDetails?.storeCode] : null
            // : userLabel == "Store" ? null : storeCode ? [storeCode] : [selectedStores[0]?.storeCode],
          },
          method: "post",
          processData: userLabel === "Store",
          accessor: "storeGetResponse",
          itemAccessor: "dataModalRecordsResponse",
        });
    };
  
    const onChangeDate = (dates) => {
      const [start, end] = dates;
      setStartDate(start);
      setEndDate(end);
      if (end) voucherApiCall(start, end);
    };
  
    const [selectedCheckBoxes, setSelectedCheckBoxes] = useState([]);
  
    console.log("sap report store data", data1);
  
    const columns = [
      {
        Header: "Start Date",
        accessor: "submittedOn",
        // Cell: (props) => {
        //   // Input date
        //   const inputDate = moment(props?.row?.original?.submittedOn);
  
        //   // Add 7 days
        //   const resultDate = inputDate.subtract(7, 'days');
  
        //   // Format the result
        //   const formattedResult = resultDate.format(displayDateFormat);
        //   const value = formattedResult;
        //   return value || "-";
        // },
      },
      {
        Header: "End Date",
        // Cell: (props) => {
        //   // Input date
        //   const inputDate = moment(props?.row?.original?.submittedOn);
  
        //   // Add 7 days
        //   const resultDate = inputDate.add(7, 'days');
  
        //   // Format the result
        //   const formattedResult = resultDate.format(displayDateFormat);
        //   const value = formattedResult;
        //   return value || "-";
        // },
        Cell: (props) => {
          const value = props?.approvedOn;
          return value || "-";
        },
      },
      {
        Header: "Voucher ID",
        accessor: "id",
        // Cell: (props) => {
        //   console.log(" - - - - - - - ", props.row.original);
        //   const value = props?.row?.original?.pendingDocs[0]?.id;
        //   return value || "-";
        // },
      },
      {
        Header: "Approved On",
        // accessor: "submittedO",
        Cell: (props) => {
          const value = props?.approvedOn;
          return value || "-";
        },
      },
      {
        Header: "Approved Amount",
        accessor: "approvedAmount",
        // Cell: (props) => {
        //   const value = props?.row?.original?.cash_deposit;
        //   return value || "-";
        // },
      },
    ];
  
  
    return (
      <div className="dashboard-container">
        <ToolbarHeader
          title="SAP Report"
          showBack={false}
          containerClassName="mt-14 mb-4"
          textClassCss={isMobileSmall ? "text-[2.5rem]" : "text-[3rem]"}
        //   renderRight={() => {
        //     if (user?.userLabel === "Store")
        //       return (
        //         <CustomButto
        //           title="Submit Cash Deposit"
        //           icon={icons.plusIcon}
        //           textClassName={isMobileSmall ? "text-[1.4rem]" : "text-[1.5rem]"}
        //           onClick={onClickSubmitCashDeposit}
        //         />
        //       );
        //   }}
        />
  
        <DatePicker
          startDate={startDate}
          endDate={endDate}
          onChange={onChangeDate}
          maxDate={new Date()}
          dateRange
        />
  
        <div className="mt-3 overflow-auto" style={{ maxHeight: "93vh" }}>
          <DetailsCard
            rows={columns}
            data={data1?.storeWiseRecordsResponses?.[0]?.documents !== undefined ? data1.storeWiseRecordsResponses?.flatMap(i => i.documents) : [] }
            customRow={(row, rowData) => {
            }}
          />
          <div className='fixed left-0 bottom-0 w-full py-5 flex justify-center item-center' style={{backgroundColor:"#e5e7eb"}}>
            <div>
            <CustomButton
                title="Download"
                wrapperClassName={`flex-1 flex-end mt-4 ${
                  storeCode?.length > 0 ? "" : "disabled-kv"
              }`}
                onClick={() => {
                  downloadFileFun()
                }}
              />
            </div>  
          </div>  
        </div>
        
      </div>
    );
  };
